export default function getPaginationRange(
  currentPage: number,
  lastPage: number
) {
  switch (true) {
    case lastPage <= 6:
      return Array.from({ length: lastPage }, (_, i) => i + 1);
    case currentPage < 4:
      return [1, 2, 3, 4, -1];
    case currentPage >= lastPage - 3:
      return [1, -1, lastPage - 3, lastPage - 2, lastPage - 1, lastPage];
    default:
      return [1, -1, currentPage - 1, currentPage, currentPage + 1, -2];
  }
}
